/* ===== MixMart — ficha de producto ===== */
(function () {
  'use strict';

  function initMinis() {
    document.querySelectorAll('.mm-pd__mini').forEach(function (b) {
      if (b.dataset.mmListo) return;
      b.dataset.mmListo = '1';
      b.addEventListener('click', function () {
        var destino = document.getElementById(b.getAttribute('data-mm-destino'));
        if (!destino) return;
        var vid = document.getElementById(b.getAttribute('data-mm-destino').replace('-img-', '-vid-'));
        var srcVideo = b.getAttribute('data-mm-video');
        if (srcVideo && vid) {
          vid.src = srcVideo;
          vid.poster = b.getAttribute('data-mm-img');
          destino.hidden = true;
          vid.hidden = false;
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          if (vid) { vid.pause(); vid.hidden = true; }
          destino.hidden = false;
          destino.src = b.getAttribute('data-mm-img');
        }
        var grupo = b.closest('.mm-pd__minis');
        if (grupo) grupo.querySelectorAll('.mm-pd__mini')
          .forEach(function (o) { o.classList.remove('mm-activa'); });
        b.classList.add('mm-activa');
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('.mm-pd').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-mm-variantes]');
      if (!datos || raiz.dataset.mmVarListo) return;
      raiz.dataset.mmVarListo = '1';

      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var campoId = raiz.querySelector('[data-mm-id]');
      var boton = raiz.querySelector('[data-mm-add]');
      var botonTexto = raiz.querySelector('[data-mm-add-texto]');
      var precio = raiz.querySelector('[data-mm-precio]');
      var antes = raiz.querySelector('[data-mm-antes]');
      var textoAgotado = raiz.getAttribute('data-mm-agotado') || 'Agotado';
      var textoComprar = botonTexto ? botonTexto.textContent.trim() : 'Añadir al carrito';

      function dinero(centavos) {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(centavos);
        }
        return '$' + (centavos / 100).toLocaleString('es-CL',
          { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }

      function seleccion() {
        var out = [];
        raiz.querySelectorAll('.mm-pd__opcion').forEach(function (op, i) {
          var act = op.querySelector('.mm-pd__pill.mm-activa');
          out[i] = act ? act.getAttribute('data-mm-valor') : null;
        });
        return out;
      }

      function actualiza() {
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return sel.every(function (val, i) { return x.options[i] === val; });
        });
        if (!v) return;
        if (campoId) campoId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = dinero(v.compare_at_price);
            antes.style.display = '';
          } else { antes.style.display = 'none'; }
        }
        if (boton) {
          boton.disabled = !v.available;
          if (botonTexto) botonTexto.textContent = v.available ? textoComprar : textoAgotado;
        }
      }

      raiz.querySelectorAll('.mm-pd__pill').forEach(function (p) {
        p.addEventListener('click', function () {
          var grupo = p.closest('.mm-pd__pills');
          grupo.querySelectorAll('.mm-pd__pill')
            .forEach(function (o) { o.classList.remove('mm-activa'); });
          p.classList.add('mm-activa');
          actualiza();
        });
      });
    });
  }

  function init() { initMinis(); initVariantes(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
